
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personalization",
      function () {
        return require("private-next-pages/personalization/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personalization"])
      });
    }
  